import React from 'react';
import { Bell, Moon, Sun, LogOut, User } from 'lucide-react';
import { useAppContext } from '../../contexts/AppContext';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/Button';
import { TextFlowLogo } from '../ui/TextFlowLogo';

export const Navbar: React.FC = () => {
  const { state, dispatch } = useAppContext();
  const { state: authState, logout } = useAuth();

  return (
    <header className="bg-background border-b border-border">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-3">
              <TextFlowLogo size={32} />
              <h1 className="text-2xl font-bold text-foreground">
                TextFlow
              </h1>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => dispatch({ type: 'TOGGLE_DARK_MODE' })}
            >
              {state.darkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </Button>
            
            <Button variant="ghost" size="sm">
              <Bell className="h-5 w-5" />
            </Button>

            <Button
              variant="ghost"
              size="sm"
              onClick={logout}
            >
              <LogOut className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};